var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.form.successful)?_c('modal',{attrs:{"hasWrapper":true},on:{"close":_vm.close}},[_c('div',{staticClass:"re-modal-title"},[_vm._t("title")],2),_c('div',{staticClass:"re-modal-message"},[_vm._t("message")],2),_c('div',{staticClass:"re-modal-buttons"},[_vm._t("buttons")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }